import React from 'react';
import {
  Box, Typography,
} from '@mui/material';

interface IField {
  label: string;
  value: string;
}
function ProductNewHeaderFieldPage(props: IField) {

  return (
    <Box className='ProductNewHeaderFieldsBox'>
      <Typography component="div" align="left">
        <span className='ProductNewHeaderFieldsLabel'>{props.label}</span>
      </Typography>
      <Typography component="div" align="left">
        <span className='ProductNewHeaderFieldsText'>{props.value}</span>
      </Typography>
    </Box>
  )
}

export default React.memo(ProductNewHeaderFieldPage);
